import { ChangeEvent, FormEvent, KeyboardEvent, useState } from "react";
import { useLoginApi } from "./service";
import { regEmail } from "components/utils/comm";

type IProps = {
  event: KeyboardEvent<HTMLInputElement>;
  form: HTMLFormElement | null;
};
export const useLogin = () => {
  const { mutate } = useLoginApi();

  const onLogin = (event: FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;

    if (form) {
      const formData = new FormData(form);
      const emlId = formData.get("emlId") as string;
      const lgnPwd = formData.get("lgnPwd") as string;

      if (form.checkValidity()) {
        mutate({
          emlId,
          lgnPwd,
        });
      }
      if (form.reportValidity()) {
        event.preventDefault();
      }
    }
  };

  const onKeyDown = ({ event, form }: IProps) => {
    /**
     * enterkey 클릭 시 로그인 진행
     * 아이디, 비밀번호 빈값 여부 확인
     */

    if (event.key !== "Enter") {
      return;
    }

    if (form && event.key === "Enter") {
      const formData = new FormData(form);
      const emlId = formData.get("emlId") as string;
      const lgnPwd = formData.get("lgnPwd") as string;

      if (form.checkValidity()) {
        mutate({
          emlId,
          lgnPwd,
        });
      }
    }
  };

  return { onLogin, onKeyDown };
};

export const useBlur = () => {
  const [isAble, setIsAble] = useState({
    id: true,
    pwd: true,
  });

  const onBlur = (e: ChangeEvent<HTMLInputElement>) => {
    const name = e.currentTarget.name;
    let value = e.currentTarget.value;

    if (!regEmail.test(value) && !!value) {
      e.currentTarget.style.color = "#e5383b";
      e.currentTarget.style.borderColor = "#e5383b";
      name === "emlId"
        ? setIsAble({
            ...isAble,
            id: true,
          })
        : setIsAble({
            ...isAble,
            pwd: true,
          });
    }
    if (regEmail.test(value) || !!value) {
      e.currentTarget.style.color = "";
      e.currentTarget.style.borderColor = "";
      name === "emlId"
        ? setIsAble({
            ...isAble,
            id: false,
          })
        : setIsAble({
            ...isAble,
            pwd: false,
          });
    }
  };

  return { onBlur };
};
